
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/concepts/decentralized-storage",
      function () {
        return require("private-next-pages/docs/concepts/decentralized-storage.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/concepts/decentralized-storage"])
      });
    }
  